import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {

  private innerInput?: HTMLInputElement;

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit(): void {
    // 這裡要等下一個 tick，確保 p-autoComplete 生成完畢
    // 先檢查是不是有子功能視窗，如果沒有則抓取主畫面物件
    setTimeout(() => {
      this.innerInput = this.el.nativeElement.querySelector('input') ?? this.el.nativeElement;
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (this.innerInput) {
      this.innerInput.value = this.innerInput.value.toUpperCase();
    }
  }
}